export interface ICustomer {
  id: string;
  fanpageId: string;
  name: string;
  alias?: string;
  createdTime: number; // Unix timestamp
  fanpageUserId: string;
  fbUserId: number;
  phones: string[];
  address: string;
  email: string[];
  locked?: number; // Trạng thái chặn — xem CUSTOMER_RESTRICT_STATUS
  lockedType?: number;
  lockedAt?: number;
  blocked?: number; // Trạng thái khóa — xem CUSTOMER_RESTRICT_STATUS
  blockedType?: number;
  blockedAt?: number;
  tagIds?: string[]; // Danh sách mã nhãn (code) đã gắn cho khách hàng
  badCustomerCount?: number; // Số lần khách hàng bị báo xấu
  badCustomerReason?: string; // Nội dung/lý do báo xấu (hiển thị khi hover icon cảnh báo)
  adIds?: string[]; // Danh sách ID quảng cáo khách hàng đã tương tác
  birthday?: string;
  gender?: number;
}

/**
 * Trạng thái chặn/khóa khách hàng — dùng chung cho cả 2 trường `locked` và `blocked`.
 * Đồng bộ với ACTION_STATUS của dialog chặn khách hàng (block-customer-dialog).
 */
export const CUSTOMER_RESTRICT_STATUS = {
  RESTRICTED: 1, // Đang bị áp dụng (chặn / khóa)
  OPEN: 2,       // Bình thường
} as const;
export type CustomerRestrictStatusValue = typeof CUSTOMER_RESTRICT_STATUS[keyof typeof CUSTOMER_RESTRICT_STATUS];
